/**
 * IS THIS A USABLE CONTACT ID? One question, one copy, and in a module a TEST CAN IMPORT.
 *
 * ⚠ IT LIVES HERE RATHER THAN IN `event-photos.service.ts` FOR A MEASURED REASON. I first exported it
 * from the service, and the row meant to assert its behaviour silently fell back to a source-text
 * regex instead, because the service cannot be imported under `--experimental-strip-types`:
 *
 *     x TypeScript parameter property is not supported in strip-only mode
 *
 * (Angular constructor parameter properties.) The row still PASSED, by taking a `.catch()` branch —
 * **a graceful fallback reads exactly like the real thing, so the predicate's behaviour was untested
 * while the suite said otherwise.** This file is pure and import-free, like `download-refusal.ts` and
 * `db-target.ts` beside it, so the assertions are on the FUNCTION and not on prose about it.
 *
 * A Mongo ObjectId on the wire is exactly 24 hex characters. Anything else is treated as ABSENT by
 * the caller, deliberately: a malformed filter the server drops looks exactly like no filter at all,
 * so it must never reach the wire claiming to be one.
 */
export const isContactIdShaped = (value: string | undefined | null): value is string =>
    typeof value === 'string' && /^[0-9a-f]{24}$/i.test(value);
